import React, { Fragment } from 'react';
import { isDesktop } from "react-device-detect";
import PropTypes from 'prop-types';

//ads
import LateralIzquierdo from '../../ads/LateralIzquierdo';
import LateralDerecho from '../../ads/LateralDerecho';
import Caja3 from '../../ads/Caja3';
import Zocalo from '../../ads/Zocalo';

//components
import Heading from './Heading';
import Video from './Video';
import Image from './Image';
import PlayerInfo from './PlayerInfo';
import Achievment from './Achievment';

import { urlAssets, titleEspecial, urlEspecial, urlEspecialVideos } from '../../Constants';

const Player = props => {
    
    console.log('Player');
    const { type, slug, backgroundColorHeader, playerInfo, achievment, content, video, quotation, quotationAuthor } = props.dataPlayer;
    
    return (
        <Fragment>
            <main className="container d-flex justify-content-around px-0">
                {isDesktop && <LateralIzquierdo />}
                <section className="container cont-layout px-0 px-md-2">
                    <Heading 
                        backgroundColorHeader={backgroundColorHeader} 
                        titleEspecial={titleEspecial} 
                        urlAssets={urlAssets} 
                        urlEspecial={urlEspecial}
                    />
                    <section className="px-3 px-md-5 content">
                        { 
                            video 
                            ? <Video urlEspecialVideos={urlEspecialVideos} slug={slug} type={type} />
                            : <Image slug={slug} achievment={achievment} type={type} name={playerInfo.name} />
                        }
                        <PlayerInfo playerInfo={playerInfo} />
                        <Achievment achievment={achievment} backgroundColorHeader={backgroundColorHeader} />
                        <article className="my-3 my-md-4">
                            <p className="mb-0 player-text">{content}</p>
                        </article>
                        {
                            (quotation && quotationAuthor) && 
                                <Fragment>
                                    <article className="my-2 my-md-4 pb-2 pb-md-3 content-quotation">
                                        <p className="mb-0 player-quotation">{quotation}</p>
                                    </article>
                                    <span className="player-quotation" style={{ color: backgroundColorHeader }} >{quotationAuthor}</span>                            
                                </Fragment>                    
                        }
                        {video && <Image slug={slug} achievment={achievment} type={type} name={playerInfo.name} />}
                        <section className="my-3 my-md-5">
                            <a className="btn px-3 py-1 text-white btn-home" href={urlEspecial}>Inicio</a>
                        </section>
                    </section>            
                    <section className="d-none d-md-block empty-space">
                        </section>                                 
                </section>
                {isDesktop && <LateralDerecho />}                
            </main>
            <section className="content-msgs">
                {!isDesktop && <Caja3 />}        
                <Zocalo isDesktop={isDesktop} />
            </section>   
        </Fragment>
    )
}

export default Player;

Player.propTypes = {
    dataPlayer: PropTypes.object.isRequired
}
